export default __webpack_public_path__ + "static/gotham-book-a472fd0d1704f384759abed2c88b34f9.woff2";